var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-divider',{staticStyle:{"height":"100%","width":"100%","margin":"0"},style:({backgroundColor:_vm.chartConfig.backgroundColor}),attrs:{"direction":"vertical"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-064cf6d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/DeviderV.vue
// module id = 845
// module chunks = 0